export const DEFAULT_ADVANCE_VALUE = 50;